import * as Api from "@api";
import { State } from "@store";
import { ActionType } from "../types";
import { ThunkAction } from "redux-thunk";
import { Entry, DirectoryAction } from "../types/directory";

function getDirectoryRequest(search: string): DirectoryAction {
  return {
    type: ActionType.GET_DIRECTORY_REQUEST,
    search,
  };
}

function getDirectorySuccess(search: string, users: Entry[]): DirectoryAction {
  return {
    type: ActionType.GET_DIRECTORY_SUCCESS,
    search,
    users,
  };
}

function getDirectoryFailure(search: string, error: Error): DirectoryAction {
  return {
    type: ActionType.GET_DIRECTORY_FAILURE,
    search,
    error,
  };
}

export function getDirectory(
  search: string,
  force: boolean = false
): ThunkAction<void, State, unknown, DirectoryAction> {
  return async (dispatch, getState) => {
    const { network, directory } = getState();

    if (
      search &&
      !force &&
      !directory[search] &&
      !network.fetching.directory[search]
    ) {
      dispatch(getDirectoryRequest(search));
      try {
        const { user } = getState();
        const directory_users = await Api.getDirectory(
          user?.access_token!,
          search
        );

        dispatch(getDirectorySuccess(search, directory_users));
      } catch (error) {
        dispatch(getDirectoryFailure(search, error));
      }
    }
  };
}
